
import { Link } from "react-router-dom";
import {
	paymentProductActionLabel,
	paymentProductHref,
} from "../../common/paymentHelpers";

const btnBase =
	"inline-flex min-h-[44px] items-center justify-center rounded-[12px] px-5 font-Vazir-600 text-[14px] no-underline transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2";

export default function ActionSection({ payment }) {
	const productHref = paymentProductHref(payment);
	const productLabel = paymentProductActionLabel(payment);
	const showProductLink = payment.state === "done" && productHref && productLabel;

	return (
		<nav
			className="flex flex-col-reverse gap-3 sm:flex-row sm:justify-center sm:gap-4"
			aria-label="اقدامات پرداخت"
		>
			<Link
				to="/"
				className={`${btnBase} border border-darkBlue/20 bg-white text-darkBlue hover:border-darkBlue/35 focus-visible:ring-darkBlue/25`}
			>
				بازگشت به خانه
			</Link>
			<Link
				to="/payment_list/"
				className={`${btnBase} border border-darkBlue/15 bg-lightCta text-darkBlue hover:bg-lightCta/80 focus-visible:ring-darkBlue/20`}
			>
				فهرست پرداخت‌ها
			</Link>
			{showProductLink && (
				<Link
					to={productHref}
					className={`${btnBase} border-0 text-white bg-gradient-to-l from-cta to-[#FF825E] shadow-[0_4px_14px_rgba(255,106,75,0.35)] hover:brightness-105 focus-visible:ring-cta/40`}
				>
					{productLabel}
				</Link>
			)}
		</nav>
	);
}
